var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCalculationsWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.185,
    height: 30.184,
    viewBox: "0 0 30.185 30.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426",
    transform: "translate(9588 3559.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M2.653,14.208h8.9a2.656,2.656,0,0,0,2.653-2.653v-8.9A2.656,2.656,0,0,0,11.555,0h-8.9A2.656,2.656,0,0,0,0,2.653v8.9A2.656,2.656,0,0,0,2.653,14.208ZM4.48,6.249H6.249V4.48a.884.884,0,1,1,1.769,0V6.249H9.786a.884.884,0,1,1,0,1.769H8.018V9.786a.884.884,0,1,1-1.769,0V8.018H4.48a.884.884,0,1,1,0-1.769Z",
    transform: "translate(-9588 -3559.803)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M282.555,0h-8.9A2.656,2.656,0,0,0,271,2.653v8.9a2.656,2.656,0,0,0,2.653,2.653h8.9a2.656,2.656,0,0,0,2.653-2.653v-8.9A2.656,2.656,0,0,0,282.555,0Zm-1.769,8.018h-5.365a.884.884,0,1,1,0-1.769h5.365a.884.884,0,1,1,0,1.769Z",
    transform: "translate(-9843.023 -3559.803)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M282.555,271h-8.9A2.656,2.656,0,0,0,271,273.653v8.9a2.656,2.656,0,0,0,2.653,2.653h8.9a2.656,2.656,0,0,0,2.653-2.653v-8.9A2.656,2.656,0,0,0,282.555,271Zm-1.769,9.727h-5.365a.884.884,0,1,1,0-1.769h5.365a.884.884,0,1,1,0,1.769Zm0-3.537h-5.365a.884.884,0,1,1,0-1.769h5.365a.884.884,0,1,1,0,1.769Z",
    transform: "translate(-9843.023 -3814.826)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M14.208,282.555v-8.9A2.656,2.656,0,0,0,11.555,271h-8.9A2.656,2.656,0,0,0,0,273.653v8.9a2.656,2.656,0,0,0,2.653,2.653h8.9A2.656,2.656,0,0,0,14.208,282.555Zm-4.573-3.23a.884.884,0,0,1-1.25,1.25l-1.25-1.25-1.25,1.25a.884.884,0,0,1-1.25-1.25l1.25-1.25-1.25-1.25a.884.884,0,0,1,1.25-1.25l1.25,1.25,1.25-1.25a.884.884,0,0,1,1.25,1.25l-1.25,1.25Z",
    transform: "translate(-9588 -3814.826)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalculationsWt);
export default __webpack_public_path__ + "static/media/ico_calculations_wt.ecb3837330d4ed840a292d326fc08ef1.svg";
export { ForwardRef as ReactComponent };